import React from "react";

import FindBuyersForProperty from "../../analytics/components/FindBuyersForProperty";
import FindBuyersStatusBoard from "../../analytics/components/FindBuyersStatusBoard";

/**
 * "Find Buyers for a Property" as a first-class Prospecting page.
 *
 * The panel itself already exists and is used on the Buyer Analytics tab. The
 * ticket asks for a button under Prospecting that "sends them to this so agents
 * can buyer match", so this page reuses the component rather than forking it:
 * one matching engine, two entry points. Agents who never open Analytics now
 * have a way in.
 *
 * No page heading here on purpose. The panel renders its own title and blurb,
 * and adding another printed "Find Buyers for a Property" twice on the screen.
 *
 * Buyer search status sits at the top, above the search, with "Match
 * properties" per buyer (DOMA 13374913603), for every CRM user (DOMA
 * 13391728224). The buyers are the same ones the search below already shows;
 * Match properties is scoped on the server to what the viewer may see.
 */
const ProspectingFindBuyersPage = () => (
  <div className="p-4 md:p-6">
    <FindBuyersStatusBoard />
    <FindBuyersForProperty />
  </div>
);

export default ProspectingFindBuyersPage;
